<template>
  <div class="us-page">

    <!-- Hero -->
    <div class="us-hero">
      <div class="d-flex align-center" style="gap:14px;">
        <v-avatar color="rgba(255,255,255,0.15)" size="46">
          <v-icon color="white" size="26">mdi-account-key-outline</v-icon>
        </v-avatar>
        <div>
          <div class="us-hero__title">Usuarios de la sede actual</div>
          <div class="us-hero__sub">Gestión de cuentas y permisos de acceso</div>
        </div>
      </div>
      <v-chip small color="rgba(255,255,255,0.15)" dark>
        <v-icon left small>mdi-shield-account-outline</v-icon> Administración
      </v-chip>
    </div>

    <v-progress-linear indeterminate color="indigo" v-if="loadingData" height="3" />

    <div class="us-body">

      <!-- Toolbar -->
      <v-card outlined class="us-toolbar-card mb-4">
        <v-card-text class="py-2 px-4 d-flex flex-wrap align-center" style="gap:10px;">
          <v-text-field
            v-model="buscar"
            placeholder="Buscar usuario..."
            prepend-inner-icon="mdi-magnify"
            dense outlined hide-details clearable
            style="max-width:320px;"
          />
          <v-chip x-small :color="usuarios.length ? 'indigo lighten-5' : 'grey lighten-3'"
            class="indigo--text text--darken-2 font-weight-medium">
            {{ usuarios.length }} usuario{{ usuarios.length !== 1 ? 's' : '' }}
          </v-chip>
          <v-spacer />
          <v-btn small depressed color="grey lighten-3"
            v-show="usuarios.length > 0"
            @click="tableToExcel('table', 'Usuarios')">
            <v-icon left small>mdi-microsoft-excel</v-icon> Excel
          </v-btn>
          <router-link
            v-show="(!$store.state.isonlyread && $store.state.createUsuario && espermitido) || isCCA"
            to="usuarioadd" style="text-decoration:none;">
            <v-btn small depressed color="indigo darken-1" dark>
              <v-icon left small>mdi-account-plus-outline</v-icon> Nuevo usuario
            </v-btn>
          </router-link>
        </v-card-text>
      </v-card>

      <!-- Tabla -->
      <v-card outlined class="us-table-card">
        <v-data-table
          :headers="headers"
          :items="tableItems"
          :search="buscar"
          :items-per-page="25"
          :footer-props="{ itemsPerPageOptions: [10, 25, 50, -1] }"
          dense
          class="us-table"
          no-data-text="Sin usuarios registrados."
          loading-text="Cargando usuarios..."
        >
          <!-- Documento -->
          <template v-slot:[`item.documento`]="{ item }">
            <span class="font-weight-medium" :title="item.uid">{{ item.documento }}</span>
          </template>

          <!-- Nombres -->
          <template v-slot:[`item.nombres`]="{ item }">
            <span :class="item.estado ? '' : 'red--text text--darken-2'">{{ item.nombres }}</span>
          </template>

          <!-- Estado -->
          <template v-slot:[`item.estadoLabel`]="{ item }">
            <v-chip x-small label
              :color="item.estado ? 'green lighten-5' : 'red lighten-5'"
              :class="item.estado ? 'green--text text--darken-3' : 'red--text text--darken-3'"
              class="font-weight-medium">
              <v-icon left x-small>{{ item.estado ? 'mdi-check-circle-outline' : 'mdi-close-circle-outline' }}</v-icon>
              {{ item.estado ? 'Activo' : 'Inactivo' }}
            </v-chip>
          </template>

          <!-- Opciones -->
          <template v-slot:[`item.opciones`]="{ item }">
            <div class="d-flex" style="gap:4px;">
              <template v-if="cid == 1 || cid == 8">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn icon color="indigo darken-1" v-on="on" @click="modificar(item.raw)">
                      <v-icon>mdi-pencil-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>Modificar</span>
                </v-tooltip>

                <v-tooltip bottom v-if="item.estado">
                  <template v-slot:activator="{ on }">
                    <v-btn icon color="red darken-1" v-on="on"
                      @click="showEliminar(item.raw.id)">
                      <v-icon>mdi-account-off-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>Desactivar</span>
                </v-tooltip>

                <v-tooltip bottom v-if="!item.estado">
                  <template v-slot:activator="{ on }">
                    <v-btn icon color="green darken-1" v-on="on"
                      @click="showEliminar(item.raw.id)">
                      <v-icon>mdi-account-check-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>Activar</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn icon color="grey darken-1" v-on="on" @click="cambiarDatos(item.raw)">
                      <v-icon>mdi-lock-reset</v-icon>
                    </v-btn>
                  </template>
                  <span>Cambiar datos de acceso</span>
                </v-tooltip>
              </template>
            </div>
          </template>

        </v-data-table>
      </v-card>

    </div>

    <!-- Modal estado (Bootstrap modal interno, se mantiene) -->
    <modal ref="modalEstado" v-bind:obj="seleccionado" v-on:exito="modalExito"/>
    <notifications group="auth" position="bottom right" />
    <Alertas ref="alertar" />

    <!-- Tabla oculta para Excel -->
    <table ref="table" style="display:none;" summary="Usuarios">
      <thead>
        <tr>
          <th>No</th><th>Documento</th><th>Nombres y Apellidos</th>
          <th>Cargos</th><th>Residencia</th><th>Estado</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, i) in tableItems" :key="item.uid">
          <td>{{ i + 1 }}</td>
          <td>{{ item.documento }}</td>
          <td>{{ item.nombres }}</td>
          <td>{{ item.cargos }}</td>
          <td>{{ item.residencia }}</td>
          <td>{{ item.estadoLabel }}</td>
        </tr>
      </tbody>
    </table>

  </div>
</template>

<script>
import gql from 'graphql-tag'
import Alertas from '@/components/AAlertas.vue'
import modal from '@/components/AEstado.vue'
import { parseJsonError } from '@/components/Utils.js'

export default {
  components: { Alertas, modal },
  data() {
    return {
      // EXCEL
      uri: 'data:application/vnd.ms-excel;base64,',
      template: '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head> <meta charset="utf-8"> <!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
      base64: function(s) { return window.btoa(unescape(encodeURIComponent(s))) },
      format: function(s, c) { return s.replace(/{(\w+)}/g, function(m, p) { return c[p] }) },
      // END EXCEL
      buscar: '',
      loadingData: false,
      seleccionado: { xid: -1, xtitle: 'X', xbody: 'X', xsql: null },
      usuarios: [],
      espermitido: false,
      isCCA: false,
      headers: [
        { text: 'No',        value: 'nro',        width: 50,  sortable: false },
        { text: 'Documento', value: 'documento',   width: 130 },
        { text: 'Nombres y Apellidos', value: 'nombres' },
        { text: 'Cargos',    value: 'cargos',      width: 160 },
        { text: 'Residencia',value: 'residencia',  width: 130 },
        { text: 'Estado',    value: 'estadoLabel', width: 100 },
        { text: 'Opciones',  value: 'opciones',    width: 130, sortable: false },
      ],
    };
  },
  computed: {
    cid() { return this.$store.state.CARGO.id; },
    tableItems() {
      return this.usuarios.map((p, i) => ({
        nro: i + 1,
        uid: p.usuario.id,
        documento: this.parseDoc(p.usuario.datos_personales),
        nombres: this.parseDatos(p.usuario.datos_personales),
        cargos: this.parseCargos(p.usuario),
        residencia: this.parseCiudad(p.usuario.datos_personales),
        estado: p.usuario.estado,
        estadoLabel: p.usuario.estado ? 'Activo' : 'Inactivo',
        raw: p.usuario,
      }));
    },
  },
  watch: {
    '$store.state.CARGO': function() {
      this.usuarios = [];
      this.getUsuarios();
    },
  },
  methods: {
    tableToExcel(table, name) {
      if (!table.nodeType) table = this.$refs.table;
      var ctx = { worksheet: name || 'Worksheet', table: table.innerHTML };
      var link = document.createElement('a');
      link.download = 'usuarios.xls';
      link.href = this.uri + this.base64(this.format(this.template, ctx));
      link.click();
    },
    parseCargos(u) {
      if (u == null) return '0';
      if (u.cargos.length > 1) return '(' + u.cargos.length + ' cargos)';
      var str = '';
      u.cargos.forEach(function(e) { str += e.cargo.nombre; });
      return str;
    },
    parseCiudad(u) {
      if (u == null) return '';
      if (u.ciudad != null) return u.ciudad.nombre;
      return '';
    },
    parseDoc(u) {
      if (u == null) return '';
      if (u.departamento != null) return u.num_doc + ' ' + u.departamento.extension;
      return u.num_doc;
    },
    parseDatos(u) {
      if (u == null) return '';
      if (u.seg_apellido == null) u.seg_apellido = '';
      return u.nombres + ' ' + u.pri_apellido + ' ' + u.seg_apellido;
    },
    modificar(u) {
      window.sessionStorage.setItem('xxusuario', JSON.stringify(u));
      this.$router.push({ name: 'usuariomod' });
    },
    cambiarDatos(u) {
      window.sessionStorage.setItem('xxusuario', JSON.stringify(u));
      this.$router.push({ name: 'datosaccesso' });
    },
    async getUsuarios() {
      var vue = this;
      var idsede = this.$store.state.CARGO.sede.id;
      if (idsede == null) {
        window.console.error('Usuarios idsede NULL');
        return;
      }
      this.loadingData = true;
      this.$refs.alertar.cargando();
      var sql = gql`query{ getSede(id:${idsede}){usuarios_activos{usuario{id,estado,login,cargos{cargo{nombre},sede{nombre},desde},datos_personales{id,num_doc,nombres,pri_apellido,seg_apellido,email,ciudad{id,nombre},departamento{id,nombre,extension}}}}} }`;
      await this.$apollo.query({
        query: sql,
        variables: {},
      }).then((data) => {
        this.$refs.alertar.reset();
        var datos = data.data.getSede.usuarios_activos;
        var users = datos.filter(function(e) { return e.usuario.datos_personales.id != 1; });
        users = users.sort(function(a, b) {
          var ae = a.usuario.estado ? -1 : 1;
          var be = b.usuario.estado ? -1 : 1;
          var n = (a.usuario.datos_personales.nombres < b.usuario.datos_personales.nombres) ? -1 : 1;
          return ae - be || n;
        });
        const uniqueArray = users.filter((thing, index) => {
          const _thing = JSON.stringify(thing);
          return index === users.findIndex(obj => JSON.stringify(obj) === _thing);
        });
        vue.usuarios = uniqueArray;
        this.loadingData = false;
      }).catch((erro) => {
        this.loadingData = false;
        this.$refs.alertar.invalido();
        this.$notify(parseJsonError(erro, 'getSede'));
      });
    },
    modalExito() {
      this.getUsuarios();
      this.seleccionado.xid = null;
    },
    showEliminar(id) {
      var obj = this.usuarios.find(x => x.usuario.id == id);
      window.console.log('jajajjjajajjajaajajaaj', obj, id);
      var msg = 'Cambiar Estado';
      var estad = !obj.usuario.estado;
      var str = 'Inactivo';
      if (obj.usuario.estado) str = 'Activo';
      var body = "El usuario '" + obj.usuario.datos_personales.nombres + ", estado actual:" + str + "' sera cambiado, el usuario no podra acceder al portal. Si Solo deseas que el usuario no tenga acceso a una sede, se recomienda quitar el cargo en esa sede.";
      var tag = gql`mutation{ cambiarEstadoUsuario(input:{id:${id},estado: ${estad}}){ok,errors{message}} }`;
      this.seleccionado = { xid: id, xtitle: msg, xbody: body, xsql: tag };
      this.$refs.modalEstado.open();
    },
  },
  mounted() {
    let sedecca_tarija = this.$store.state.CARGO.sede.id;
    this.isCCA = this.$store.state.DATA_USER.id == 6007 && sedecca_tarija == 10;
    let idcargo = this.$store.state.CARGO.id;
    this.espermitido = idcargo == 8 || idcargo == 1;
    this.getUsuarios();
  },
};
</script>

<style scoped>
.us-page { min-height: 100vh; background: #f5f7fa; }

.us-hero {
  background: linear-gradient(120deg, #1a237e 0%, #283593 50%, #1565c0 100%);
  padding: 20px 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}
.us-hero__title { font-size: 1.15rem; font-weight: 700; color: #fff; letter-spacing: 0.02em; }
.us-hero__sub   { font-size: 0.78rem; color: rgba(255,255,255,0.65); margin-top: 2px; }

.us-body { padding: 20px 24px; }

.us-toolbar-card { border-radius: 10px !important; border-color: #e3e8f0 !important; }

.us-table-card { border-radius: 10px !important; border-color: #e3e8f0 !important; overflow: hidden; }

.us-table >>> thead tr th {
  background: #e8edf7 !important;
  color: #1a237e !important;
  font-size: 0.72rem !important;
  font-weight: 700 !important;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-bottom: 2px solid #c5cae9 !important;
  padding: 6px 12px !important;
}
.us-table >>> tbody tr:hover { background: #f0f4ff !important; }
.us-table >>> tbody tr td {
  font-size: 0.82rem;
  border-bottom: 1px solid #f0f0f0 !important;
  padding: 5px 12px !important;
  vertical-align: middle;
}
</style>
